import(/* webpackMode: "eager", webpackExports: ["AppHomePageSkeleton"] */ "/var/www/schedly/calcom/apps/web/app/(use-page-wrapper)/apps/(homepage)/skeleton.tsx");
